module.exports = __webpack_public_path__ + "img/process-icon-1.5891a0ad.svg";